<template>
  <div>
    <div class="mask" :style="{ height: post_height, width: post_width }" v-show="showBaking || showProduct"></div>
    <div class="header_content" @mouseleave="showMenu(-1)" :class="{ 'header-swipe': isHome && isChoose }">
      <div class="header_content-mid">
        <div class="header_content-mid-icon" v-bgImg="require('@@/assets/img/westa/home/logo黑2.png')" v-show="!isHome || !isChoose"></div>
        <div class="header_content-mid-icon" v-bgImg="require('@@/assets/img/westa/home/logo彩白.png')" v-show="isHome && isChoose">
        </div>
        <div class="header_content-mid-menu">
          <div class="header_content-mid-menu-div" @mouseover="showMenu(0)">
            <a href="/home" :class="{ 'header_content-mid-menu-div-active': chooseIndex === 0 }">{{ utils.local(lang, "首页") }}</a>
          </div>
          <div class="header_content-mid-menu-div">
            <el-dropdown trigger="hover" @command="handleAboutCommand">
              <a :class="{ 'header_content-mid-menu-div-active': chooseIndex === 1 }" class="el-dropdown-link">
                {{ utils.local(lang, "关于WESTA") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </a>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="changdi">长帝</el-dropdown-item>
                <el-dropdown-item command="pusteen">普斯汀</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="header_content-mid-menu-div" @mouseenter="showMenu(2)">
            <a :href="'/product?id=' + chooseProduct" :class="{ 'header_content-mid-menu-div-active': chooseIndex === 2 }">{{ utils.local(lang, "产品中心") }}</a>
          </div>
          <div class="header_content-mid-menu-div" @mouseover="showMenu(3)">
            <a href="/activity" :class="{ 'header_content-mid-menu-div-active': chooseIndex === 3 }">{{ utils.local(lang, "品牌活动") }}</a>
          </div>
          <div class="header_content-mid-menu-div" @mouseenter="showMenu(4)" v-show="chooseLang === 'CN'">
            <a :href="'/baking?id=' + video_id" :class="{ 'header_content-mid-menu-div-active': chooseIndex === 4 }">长帝烘焙</a>
          </div>
          <div class="header_content-mid-menu-div" @mouseover="showMenu(5)" v-show="chooseLang === 'CN'">
            <a href="/service" :class="{ 'header_content-mid-menu-div-active': chooseIndex === 5 }">在线服务</a>
          </div>
          <div class="header_content-mid-menu-div" @mouseover="showMenu(6)" v-show="chooseLang === 'CN'">
            <a href="/shopping" :class="{ 'header_content-mid-menu-div-active': chooseIndex === 6 }">在线购买</a>
          </div>
        </div>
        <div class="header_content-mid-lang">
          <span :class="{ 'header_content-mid-lang-active': chooseLang === 'CN' }" @click="chooseLangMethod('CN')">中文简体</span>
          <span>/</span>
          <span :class="{ 'header_content-mid-lang-active': chooseLang === 'EN' }" @click="chooseLangMethod('EN')">EN</span>
        </div>

        <!-- <div class="header_content-mid-search">
          <div
            class="header_content-mid-search-icon"
            v-bgImg="require('@@/assets/img/westa/店招/搜索.png')"
          ></div>
        </div>-->
        <!-- <router-link
          to="search"
          class="header_content-mid-search"
          v-bgImg="require('@@/assets/img/westa/home/搜索按钮黑色.png')"
        ></router-link>-->
        <!-- <div class="header_content-mid-text" @click="toPath('/shopping')">在线购买</div>
        <div class="header_content-mid-line"></div>
        <div class="header_content-mid-text" @click="toPath('/shopping')">联系我们</div>-->
      </div>
      <!-- 产品中心 -->
      <transition name="el-fade-in">
        <div class="header_content-product" v-show="showProduct">
          <div class="header_content-product-mid">
            <div class="header_content-product-mid-l1">
              <a v-for="(item, index) in website_product_categories" :key="index" @mouseover="chooseProduct = item.category_id" :class="{ 'header_content-product-mid-l1-item-active': chooseProduct === item.category_id }" :href="'/product?id=' + item.category_id" class="header_content-product-mid-l1-item">
                <div class="header_content-product-mid-l1-item-name">{{ item.category_name }}</div>
                <div class="header_content-product-mid-l1-item-img" v-bgImg="utils.getQiniuWidthUrl(item.category_icon_real, 120, 3, 'png')"></div>
              </a>
            </div>
            <div class="header_content-product-mid-l2">
              <a :href="'/detail?id=' + item.product_id" target="_blank" class="header_content-product-mid-l2-item" v-for="(item, index) in getsecProduct" :key="index" @mouseover="getPicMethod(item.product_id)" :class="{ 'header_content-product-mid-l1-item-active': chooseProduct2 === item.product_id }">
                <div class="header_content-product-mid-l2-item-name">{{ item.product_model }}</div>
              </a>
              <a :href="'/product?id=' + chooseProduct" class="header_content-product-mid-l2-item" @mouseenter="chooseProduct2 = ''">
                <div class="header_content-product-mid-l2-item-name">更多产品...</div>
              </a>
            </div>
            <a :href="'/detail?id=' + chooseProduct2" target="_blank" class="header_content-product-mid-l3">
              <div class="header_content-product-mid-l3-img" v-bgImg="utils.getQiniuWidthUrl(getPic, 646, 3, 'webp')"></div>
            </a>
          </div>
        </div>
      </transition>
      <!-- 长帝烘焙 -->
      <transition name="el-fade-in">
        <div class="header_content-baking" v-show="showBaking">
          <div class="header_content-baking-mid">
            <!-- <div class="header_content-baking-mid-left">
              <div class="header_content-baking-mid-left-flex">
                <div
                  class="header_content-baking-mid-left-icon"
                  v-bgImg="require('@@/assets/img/westa/home/wx.png')"
                ></div>
                <p>官方微信</p>
              </div>
              <img
                class="footer_content-tags-img"
                src="@@/assets/img/westa/home/weixin.png"
                width="92"
                height="92"
              />
              <p class="header_content-baking-mid-left-text">扫码了解更多食谱</p>
            </div>
            <div class="header_content-baking-mid-left">
              <div class="header_content-baking-mid-left-flex">
                <div
                  class="header_content-baking-mid-left-icon"
                  v-bgImg="require('@@/assets/img/westa/home/wb.png')"
                ></div>
                <p>官方微博</p>
              </div>
              <img
                class="footer_content-tags-img"
                src="@@/assets/img/westa/home/weibo.png"
                width="92"
                height="92"
              />
              <p class="header_content-baking-mid-left-text" style="color:#fff;">扫码了解更多食谱</p>
            </div>-->
            <div class="header_content-baking-mid-post" v-bgImg="require('@@/assets/img/westa/home/300x200.png')"></div>
            <div class="header_content-baking-mid-line"></div>
            <a :href="'/baking?id=' + item.category_id" class="header_content-baking-mid-right" v-for="item in website_video_categories" :key="item.category_id">
              <div class="header_content-baking-mid-right-icon" v-bgImg="utils.getQiniuWidthUrl(item.category_icon, 72, 3, 'png')"></div>
              <div>{{ item.category_title }}</div>
            </a>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { setTimeout } from "timers";
import { log } from "util";
export default {
  data() {
    return {
      lang: "base-header",
      searchContent: "",
      showBaking: false,
      showProduct: false,
      product_height: "",
      product_level1: [
        {
          name: "台式电烤箱"
        },
        {
          name: "嵌入式烤箱"
        },
        {
          name: "蒸烤箱"
        },
        {
          name: "厨师机"
        },
        {
          name: "烘焙工具"
        }
      ],
      product_level2: [
        {
          name: "长帝CRWF2NE烤箱"
        },
        {
          name: "长帝CRWF2NE2烤箱"
        },
        {
          name: "长帝CRWF2NE3烤箱"
        },
        {
          name: "长帝CRWF2NE4烤箱"
        },
        {
          name: "长帝CRWF2NE5烤箱"
        },
        {
          name: "长帝CRWF2NE6烤箱"
        },
        {
          name: "长帝CRWF2NE烤箱"
        }
      ],
      website_product_categories: [],
      website_video_categories: [],
      video_id: "",
      ifShow: false,
      chooseProduct: "",
      chooseProduct2: "",
      getPic: "",
      post_height: "",
      post_width: "",
      chooseLang: "CN"
    };
  },
  props: {
    chooseIndex: {
      type: Number,
      default: 1000
    },
    isHome: {
      type: Boolean,
      default: false
    },
    isChoose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getsecProduct() {
      let arr = [];
      let len = this.product_level2.length;
      for (let i = 0; i < len; i++) {
        if (
          this.product_level2[i].product_website_product_category_id ===
          this.chooseProduct
        ) {
          arr.push(this.product_level2[i]);
        }
      }

      // if (arr.length < this.website_product_categories.length) {
      // } else {
      //   arr = arr.slice(0, this.website_product_categories.length - 1);
      // }
      if (arr.length) {
        this.chooseProduct2 = arr[0].product_id;
      }
      return arr;
    }
  },
  created() {
    this.chooseLang = this.utils.getCookie("lang");
    this.getCategories();
    this.getWebsiteVideoCategories();
    setTimeout(() => {
      this.ifShow = true;
    }, 100);

    console.log(this.chooseLang);
  },
  mounted() {
    if (this.isChoose) {
      window.addEventListener("scroll", this.handleScroll, true);
    }
    this.init();
  },
  methods: {
    init() {
      this.post_height = window.innerHeight + "px";
      this.post_width = window.innerWidth + "px";

      // this.middle_height = window.innerHeight;
    },
    toPath(path) {
      this.$router.push(path);
    },
    toPath1(path, index) {
      this.$router.push({
        path: path,
        query: {
          id: index
        }
      });
    },
    handleScroll() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      if (top === 0) {
        if (this.showBaking || this.showProduct) {
        } else {
          this.isHome = true;
        }

        // return;
      } else {
        this.isHome = false;
      }
      // console.log(top);
    },
    showMenu(index) {
      if (!this.ifShow) {
        return;
      }
      this.showBaking = false;
      this.showProduct = false;
      if (this.isChoose) {
        let top =
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          window.pageYOffset;
        if (top === 0) {
          this.isHome = true;
          // return;
        } else {
          this.isHome = false;
        }
      }

      switch (index) {
        case 2:
          this.showProduct = true;
          this.isHome = false;
          break;
        case 4:
          this.showBaking = true;
          this.isHome = false;
          break;
        default:
          break;
      }
    },

    getCategories() {
      console.log(this.chooseLang);
      if (this.chooseLang === "CN") {
        let product_categories = JSON.parse(
          localStorage.getItem("product_categories")
        );
        if (product_categories === null) {
          let params = {};
          this.req
            .get(
              url_api_web_websiteProductCategory_getWebsiteProductCategories,
              this.qs.stringify(params)
            )
            .then(result => {
              this.website_product_categories =
                result.website_product_categories;
              localStorage.setItem(
                "product_categories",
                JSON.stringify(this.website_product_categories)
              );
              this.chooseProduct = this.website_product_categories[0].category_id;
              let len = this.website_product_categories.length;
              this.product_height = 98 * len + "px";
              this.getProducts();
            })
            .catch(error => { });
        } else {
          this.website_product_categories = product_categories;
          this.chooseProduct = this.website_product_categories[0].category_id;
          let len = this.website_product_categories.length;
          this.product_height = 98 * len + "px";
          this.getProducts();
        }
      } else if (this.chooseLang === "EN") {
        let product_categories = JSON.parse(
          localStorage.getItem("product_categories-en")
        );
        if (product_categories === null) {
          let params = {};
          this.req
            .get(
              url_api_web_websiteProductCategory_getWebsiteProductCategories,
              this.qs.stringify(params)
            )
            .then(result => {
              this.website_product_categories =
                result.website_product_categories;
              localStorage.setItem(
                "product_categories-en",
                JSON.stringify(this.website_product_categories)
              );
              this.chooseProduct = this.website_product_categories[0].category_id;
              let len = this.website_product_categories.length;
              this.product_height = 98 * len + "px";
              this.getProducts();
            })
            .catch(error => { });
        } else {
          this.website_product_categories = product_categories;
          this.chooseProduct = this.website_product_categories[0].category_id;
          let len = this.website_product_categories.length;
          this.product_height = 98 * len + "px";
          this.getProducts();
        }
      }
    },
    getProducts() {
      if (this.chooseLang === "CN") {
        let product_nav = JSON.parse(localStorage.getItem("product_nav"));
        if (product_nav === null) {
          let params = {};
          this.req
            .get(
              url_api_web_websiteProduct_getNavWebsiteProducts,
              this.qs.stringify(params)
            )
            .then(result => {
              this.product_level2 = result.website_products;
              localStorage.setItem(
                "product_nav",
                JSON.stringify(this.website_products)
              );
            })
            .catch(error => { });
        } else {
          this.product_level2 = product_nav;
        }
      } else if (this.chooseLang === "EN") {
        let product_nav = JSON.parse(localStorage.getItem("product_nav-en"));
        if (product_nav === null) {
          let params = {};
          this.req
            .get(
              url_api_web_websiteProduct_getNavWebsiteProducts,
              this.qs.stringify(params)
            )
            .then(result => {
              this.product_level2 = result.website_products;
              localStorage.setItem(
                "product_nav-en",
                JSON.stringify(this.website_products)
              );
            })
            .catch(error => { });
        } else {
          this.product_level2 = product_nav;
        }
      }
    },
    getWebsiteVideoCategories() {
      if (this.chooseLang === "CN") {
        let video_categories = JSON.parse(
          localStorage.getItem("video_categories")
        );
        if (video_categories === null) {
          let params = {};
          this.req
            .get(
              url_api_web_websiteVideoCategory_getWebsiteVideoCategories,
              this.qs.stringify(params)
            )
            .then(result => {
              this.website_video_categories = result.website_video_categories;
              this.video_id = result.website_video_categories[0].category_id;
              localStorage.setItem(
                "video_categories",
                JSON.stringify(this.website_video_categories)
              );
            })
            .catch(error => { });
        } else {
          this.website_video_categories = video_categories;
          this.video_id = this.website_video_categories[0].category_id;
        }
      } else if (this.chooseLang === "EN") {
        let video_categories = JSON.parse(
          localStorage.getItem("video_categories-en")
        );
        if (video_categories === null) {
          let params = {};
          this.req
            .get(
              url_api_web_websiteVideoCategory_getWebsiteVideoCategories,
              this.qs.stringify(params)
            )
            .then(result => {
              this.website_video_categories = result.website_video_categories;
              this.video_id = result.website_video_categories[0].category_id;
              localStorage.setItem(
                "video_categories-en",
                JSON.stringify(this.website_video_categories)
              );
            })
            .catch(error => { });
        } else {
          this.website_video_categories = video_categories;
          this.video_id = this.website_video_categories[0].category_id;
        }
      }
    },

    getPicMethod(id) {
      this.chooseProduct2 = id;
      let len = this.product_level2.length;
      for (let i = 0; i < len; i++) {
        if (this.product_level2[i].product_id === id) {
          this.getPic = this.product_level2[i].product_nav_face;
          return;
        }
      }
    },
    chooseLangMethod(lang) {
      console.log(lang);
      this.chooseLang = lang;
      this.utils.setCookie("lang", lang, "1y", "/");
      // localStorage.removeItem('product_categories');
      // localStorage.removeItem('video_categories');
      window.location.href = "/";
    },
    handleAboutCommand(command) {
      console.log(command);
      if (command === 'changdi') {
        this.$router.push('/about');
      } else if (command === 'pusteen') {
        window.open('http://www.pusteen.com/cn/home', '_blank');
      }
    }
  },
  destroyed() {
    // console.log("destory");
    if (this.isChoose) {
      window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    }
  }
};
</script>

<style lang="less" scoped>
a {
  &:active {
    color: #181f99;
  }
}

.header_content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 64px;
  background: #fff;
  z-index: 999;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.08);

  &-mid {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    &-icon {
      width: 117px;
      height: 36px;
      // margin-right: 60px;
    }

    &-menu {
      display: flex;

      // margin-left: 200px;
      &-div {
        // width: 84px;
        height: 64px;
        line-height: 64px;
        padding: 0 20px;
        cursor: pointer;

        &-active {
          color: #181f99;
        }

        &:hover {
          color: #181f99;
        }
      }
    }

    &-search {
      width: 24px;
      height: 24px;
      margin-right: 18px;
    }

    &-line {
      width: 1px;
      height: 20px;
      margin-left: 12px;
      margin-right: 12px;
      background: #999;
    }

    &-lang {
      cursor: pointer;

      &-active {
        color: #181f99;
      }
    }
  }

  &-product {
    width: 100%;
    background: transparent;
    // min-height: 98px;
    height: 490px;

    position: absolute;
    top: 64px;
    left: 0;

    // -webkit-transition: opacity 0.5s;
    // -moz-transition: opacity 0.5s;
    // -ms-transition: opacity 0.5s;
    // -o-transition: opacity 0.5s;
    // transition: opacity 0.5s;
    &-mid {
      background: #fff;
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      // align-items: center;
      height: 100%;

      &-l1 {
        border-left: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
        overflow-y: scroll;
        box-sizing: border-box;
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;

        &::-webkit-scrollbar {
          width: 0 !important;
        }

        &-item {
          width: 268px;
          height: 98px;
          display: flex;
          justify-content: center;
          align-items: center;

          &-name {
            color: #333;
            width: 140px;
            text-align: center;
          }

          &-img {
            width: 120px;
            height: 98px;
          }

          &:hover {
            background: #f2f2f2;
          }

          &-active {
            background: #f2f2f2;
          }
        }
      }

      &-l2 {
        border-right: 1px solid #e5e5e5;
        overflow-y: scroll;
        box-sizing: border-box;
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;

        &::-webkit-scrollbar {
          width: 0 !important;
        }

        // width: 284px;
        &-item {
          width: 283px;
          height: 98px;
          display: flex;
          justify-content: center;
          align-items: center;

          &-name {
            color: #333;
            width: 140px;
            text-align: center;
          }

          &:hover {
            background: #f2f2f2;
          }
        }
      }

      &-l3 {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f2f2f2;
        height: 100%;

        &-img {
          width: 646px;
          height: 490px;
        }
      }
    }
  }

  &-baking {
    width: 100%;
    height: 240px;
    position: absolute;
    top: 64px;
    left: 0;
    background: #fff;

    &-mid {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &-post {
        width: 300px;
        height: 200px;
      }

      &-left {
        &-flex {
          display: flex;
          align-items: center;
          margin-bottom: 9px;
          font-size: 15px;
          color: #333;
        }

        &-icon {
          width: 26px;
          height: 26px;
          margin-right: 6px;
        }

        &-text {
          font-size: 15px;
          color: #999;
          margin-top: 9px;
        }
      }

      &-line {
        width: 1px;
        height: 60%;
        background: #f2f2f2;
      }

      &-right {
        color: #333;

        // min-width: 898px;
        &-icon {
          width: 72px;
          height: 72px;
          margin-bottom: 36px;
        }
      }
    }
  }
}

.last-li {
  border-bottom: 0;
}

.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
}

.header-swipe {
  background: transparent;
  box-shadow: none;

  & a {
    color: #fff;

    &:active {
      color: #181f99;
    }
  }
}

// 自定义下拉菜单样式
.el-dropdown-link {
  color: inherit;
  text-decoration: none;

  &:hover {
    color: #181f99;
  }
}

.el-dropdown-menu {
  .el-dropdown-item {
    &:hover {
      background-color: #f2f2f2;
      color: #181f99;
    }
  }
}
</style>
